import { LiquidationAttributes } from './LiquidationAttributes'

export default LiquidationAttributes
